import React, { useEffect, useRef } from 'react';
import { IconWarning } from './icons';
import './ConfirmDialog.scss';

const ConfirmDialog = ({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  Icon = IconWarning,
  onConfirm,
  onCancel,
}) => {
  const confirmRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement;
    confirmRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
      if (e.key === 'Enter' && document.activeElement === confirmRef.current) {
        // default Enter behavior already triggers the button
      }
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      prev?.focus?.();
    };
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="wm-confirm-overlay" onMouseDown={onCancel} role="dialog" aria-modal="true">
      <div className="wm-confirm" onMouseDown={(e) => e.stopPropagation()}>
        <div className={`wm-confirm__icon ${destructive ? 'is-destructive' : ''}`}>
          <Icon size={26} />
        </div>
        <div className="wm-confirm__body">
          <h3 className="wm-confirm__title">{title}</h3>
          {message && <p className="wm-confirm__msg">{message}</p>}
        </div>
        <div className="wm-confirm__actions">
          <button className="wm-confirm__btn wm-confirm__btn--ghost" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            ref={confirmRef}
            className={`wm-confirm__btn ${destructive ? 'wm-confirm__btn--danger' : 'wm-confirm__btn--primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
